var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterpriseManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#FFF3E0",
    stroke: "#FF9800",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 28,
    height: 28,
    rx: 2,
    fill: "#FF9800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 1,
    fill: "#FF9800"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 24,
    r: 1,
    fill: "#FF9800"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 24,
    r: 1,
    fill: "#FF9800"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 34,
    r: 1,
    fill: "#FF9800"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 1,
    fill: "#FF9800"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 34,
    r: 1,
    fill: "#FF9800"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 44,
    r: 1,
    fill: "#FF9800"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 44,
    r: 1,
    fill: "#FF9800"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 1,
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseManagement);
export default __webpack_public_path__ + "static/media/enterprise-management.d00b28ec695fc2eda91a70d02f19e11b.svg";
export { ForwardRef as ReactComponent };